module.exports = __webpack_public_path__ + "img/locations.3b3d8407.svg";